import { render, staticRenderFns } from "./LocationViewer.vue?vue&type=template&id=08970f19&scoped=true"
import script from "./LocationViewer.vue?vue&type=script&lang=js"
export * from "./LocationViewer.vue?vue&type=script&lang=js"
import style0 from "./LocationViewer.vue?vue&type=style&index=0&id=08970f19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08970f19",
  null
  
)

export default component.exports